import { env } from '@/utils/env';
import { createHttpClient } from './httpClient';

const WORDPRESS_BASE_URL = (
  env('NEXT_PUBLIC_ENV') === 'LOCAL' ? 'http://localhost:3000' : env('NEXT_PUBLIC_ENV_FRONTEND_ORIGIN')
) as string;

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */
export const wordpressClient = createHttpClient({
  baseURL: WORDPRESS_BASE_URL,
  options: {
    credentials: 'include',
  },
  headers: {
    'Content-Type': 'application/json',
  },
});
